// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"3cd19a68","621":"45560156","743":"bfa8f49c"}[chunkId] + ".chunk.js";
};